import { useEffect } from 'react';
import { analytics } from '@/services/analytics';
import { PageName } from '@goodneighbor/analytics';

export function useAnalyticsPageView(pageName: PageName) {
  useEffect(() => {
    let cancelled = false;
    analytics
      .initialize()
      .then(() => {
        if (cancelled) return;
        analytics.anonymize();
        analytics.page(pageName);
      })
      .catch((error) => {
        if (cancelled) return;
        // eslint-disable-next-line no-console
        console.error(
          `[useAnalyticsPageView] Analytics initialization failed:`,
          error
        );
      });
    return () => {
      cancelled = true;
    };
  }, [pageName]);
}
